<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-pc-detail-card">
    <v-row class="com-pc-card-header">
      <div class="com-pc-card-title">{{ text.obsInfo }} {{ appTime }}</div>
      <v-tooltip bottom max-width="350px">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2"
            >help_outline</v-icon
          >
        </template>
        <span>
          <span>
            {{ legendStr.swStg.swStgMsg1 }}
            <br />
            {{ legendStr.swStg.swStgMsg2 }}
            <br />
          </span>
          <v-row no-gutters class="pt-1 pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-flood legend-swstg-item">
                  {{ legendStr.swStg.flood1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-flood legend-swstg-detail">
                  {{ legendStr.swStg.flood2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-danger legend-swstg-item">
                  {{ legendStr.swStg.danger1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-danger legend-swstg-detail">
                  {{ legendStr.swStg.danger2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-start legend-swstg-item">
                  {{ legendStr.swStg.start1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-start legend-swstg-detail">
                  {{ legendStr.swStg.start2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
        </span>
      </v-tooltip>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            dark
            small
            class="pl-2 refresh-icon-size"
            @click="renew"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ this.tooltipStr.refresh }}</span>
      </v-tooltip>
      <v-btn
        class="com-pc-card-button"
        @click="openMap()"
        max-height="20"
      >
        <v-icon>link</v-icon> {{ text.checkMap }}
      </v-btn>
    </v-row>
    <v-expansion-panels accordion class="tm-pc-detail-info-panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-1 pr-4">
          <v-row no-gutters align="center" justify="start">
            <v-col md="auto" class="ma-2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <img
                    src="/kawabou/img/obs_icons/obs_swstg.svg"
                    class="tm-pc-detail-icon"
                    v-on="on"
                  />
                </template>
                <span>{{ text.obsType }}</span>
              </v-tooltip>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ swStageList.mtSwobs.obsInfo.swobsNmKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ swStageList.mtSwobs.obsInfo.swobsNm }}
              </div>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                <span v-if="swStageList.mtSwobs.obsInfo.swrsysKana"
                  >{{ swStageList.mtSwobs.obsInfo.swrsysKana
                  }}{{ text.rsysKana }}</span
                >
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ swStageList.mtSwobs.obsInfo.swrsysNm }}{{ text.rsys }}
              </div>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ swStageList.mtSwobs.obsInfo.swrvrKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ swStageList.mtSwobs.obsInfo.swrvrNm }}
              </div>
            </v-col>
            <div class="tm-pc-detail-frame-space"></div>

            <v-col class="pl-2">
              <!-- 観測値 -->
              <div class="tm-pc-detail-info-latest-value pb-1">
                <span>{{ text.obs_title }}</span>
                <span class="pl-2">{{ swStageList.curt.obsTime }}</span>
                <span class="annotation tm-pc-detail-info-annotation">
                  {{ swStgMsg.annotation }}</span
                >
              </div>
              <div class="tm-pc-detail-border-line pt-1">
                <span class="tm-pc-detail-info-curt-title"
                  >{{ text.category }}:</span
                >
                <span class="tm-pc-detail-info-curt-value">{{
                  swStageList.curt.stgHght
                }}</span>
                <span
                  class="tm-pc-detail-info-curt-unit"
                  v-html="text.stgUnit"
                ></span>
                <span
                  class="tm-pc-detail-info-curt-title tm-pc-stg-fld-color"
                  :stg-fld-color="fldColor"
                  :label-height="labelHeight"
                >
                  {{ stgOvlvlNm }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense>
            <!-- 観測所情報 -->
            <v-list-item
              v-for="(item, index) in swobsInfo"
              :key="`obs-${index}`"
              class="tm-pc-detail-info-list-item"
            >
              <v-row no-gutters>
                <v-col class="tm-pc-detail-info-list-title">{{
                  item.title
                }}</v-col>
                <v-col class="tm-pc-detail-info-list-value">
                  <div
                    v-if="item.itmkndCd"
                    class="tm-pc-link"
                    @click="openObs(item.ofcCd, item.itmkndCd, item.obsCd)"
                  >
                    {{ item.value }}
                  </div>
                  <div v-else>
                    <span style="line-break: strict">{{ item.value }}</span>
                    <span
                      class="tm-pc-detail-info-curt-unit"
                      v-html="item.unit"
                    ></span>
                    <span class="list-value">{{ item.code }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-list-item>

            <!-- コード -->
            <v-list-item
              v-for="(item, index) in codeInfo"
              :key="`obs-${index}`"
              class="tm-pc-detail-info-list-item"
            >
              <v-row no-gutters>
                <v-col class="tm-pc-detail-info-list-title">{{
                  item.title
                }}</v-col>
                <v-col class="tm-pc-detail-info-list-value">
                  <div
                    v-if="item.itmkndCd"
                    class="tm-pc-link"
                    @click="openObs(item.ofcCd, item.itmkndCd, item.obsCd)"
                  >
                    {{ item.value }}
                  </div>
                  <div v-else>
                    <span>{{ item.value }}</span>
                    <span
                      class="tm-pc-detail-info-curt-unit"
                      v-html="item.unit"
                    ></span>
                    <span class="list-value">{{ item.code }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>

          <!-- 基準値 -->
          <div class="tm-pc-detail-info-latest-value">
            {{ text.standard_title }}
          </div>
          <div class="tm-pc-detail-border-line">
            <span v-for="(item, index) in standardValue" :key="`sd-${index}`">
              <span class="tm-pc-detail-info-curt-title"
                >{{ item.title }}:</span
              >
              <span class="tm-pc-detail-info-curt-value">{{ item.value }}</span>
              <span
                class="tm-pc-detail-info-curt-unit"
                v-html="item.unit"
              ></span>
              &nbsp;
            </span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
import Util from "../../../lib/util";
import mixin from "./../../../lib/mixin.js";

/**
 * 川の防災情報 [PC]危機管理 (詳細)観測所情報カード
 * TmSwStageDetailInfo.vue
 * @author LIS
 */

export default {
  name: "tm-sw-stage-detail-info",
  mixins: [mixin],
  data() {
    return {
      text: {
        obsInfo: "観測所情報",
        obsType: this.$store.state.app.config.replaceNameConfig.swstg,
        obs_title: "■最新観測値",
        standard_title: "■基準値",
        code_title: "■コード",
        category: "堤防天端からの高さ",
        stgUnit: "m",
        rsys: "水系",
        rsysKana: "すいけい",
        checkMap: "地図で確認",
      },
      fldColor: "normal",
      labelHeight: "other",
      stgOvlvlNm: "",
    };
  },
  computed: {
    /**
     * 表示時刻
     */
    appTime: {
      get() {
        return Util.formatDate(this.$store.state.app.appTime);
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.Swin.selectedSwParam;
      },
    },
    // 危機管理情報
    swStageList: {
      get() {
        return this.$store.state.Swin.selectedSw;
      },
    },
    /**
     * 危機管理観測所情報 取得
     */
    swobsInfo: {
      get() {
        return this.$store.state.Swin.selectedSw.obsInfo;
      },
    },
    /**
     * 基準値 取得
     */
    standardValue: {
      get() {
        return this.$store.state.Swin.selectedSw.standardValue;
      },
    },
    /**
     * コード値 取得
     */
    codeInfo: {
      get() {
        return this.$store.state.Swin.selectedSw.codeValue;
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
    /**
     * 注記文言
     */
    swStgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.swStg;
      },
    },
  },
  mounted() {
    /** 水位超過 着色 */
    const crntfld = this.swStageList.curt;
    this.fldColor = this.setFloodColor(crntfld.swstgOvlvl);
    this.labelHeight = this.setLablHeight(crntfld.swstgOvlvl);
    this.stgOvlvlNm = this.getSwStgOvlvlNm(crntfld.swstgOvlvl);
  },
  methods: {
    // 観測所リンク
    openObs(ofcCd, itmkndCd, obsCd) {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            ofcCd: ofcCd,
            itmkndCd: itmkndCd,
            obsCd: obsCd,
            appTime: Util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            appTimeRound: Util.formatDate(
              this.$sotre.state.app.appTimeRound,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      } else {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            ofcCd: ofcCd,
            itmkndCd: itmkndCd,
            obsCd: obsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      }
    },
    /**
     * 更新クリックイベント
     */
    renew() {
      this.$log.debug("[TmObs] renew()");
      this.$store.commit("app/renewTime");

      // URLクエリ更新
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["isCurrent"] = true;
      delete setQuery["appTime"];
      delete setQuery["appTimeRound"];
      delete setQuery["tmtime"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /** 水位超過 着色 */
    setFloodColor(ovlvl) {
      if (ovlvl === 90) {
        // 氾濫開始水位超過(危機管理)
        return "occurrence";
      } else if (ovlvl === 80) {
        // 氾濫危険水位超過
        return "danger";
      } else if (ovlvl === 30) {
        // 観測開始水位超過(危機管理)
        return "caution";
      } else {
        // 平常
        return "normal";
      }
    },
    setLablHeight(stgOvlvl) {
      if (10 <= stgOvlvl && stgOvlvl <= 90) {
        return "stgOvlvl";
      }
      return "other";
    },
    getSwStgOvlvlNm(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "氾濫開始水位超過";
      } else if (stgOvlvl === 80) {
        return "危険水位超過";
      } else if (stgOvlvl === 30) {
        return "水位観測中";
      }
      return "";
    },
    /** 同タブ内でマップ画面に遷移 */
    openMap() {
      let path = "/pc/tm";
      if (this.$store.state.map.zoom !== undefined) {
        this.routerPushTmSw(path);
      } else {
        this.routerOpenTmSw(path);
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
